import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { TrashService } from "./trash.service";
import * as _ from 'lodash';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { DashboardService } from '../dashboard/dashboard.service';
import { SharedService } from '../services/shared.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment-timezone';
import { MatSort } from '@angular/material/sort';
import { FilterService } from '../services/filter.service';

@Component({
	selector: 'app-trash',
	templateUrl: './trash.component.html',
	styleUrls: ['./trash.component.scss']
})
export class TrashComponent implements OnInit {

	@ViewChild(MatSort) sort: MatSort;

	trashForms: any = [];
	sortForms = ["All Forms"];
	displayNoRecords: boolean = false;
	displayedColumns = ["select", "sortTopics", "subTopics", "name", "sortSenders", "sortForms", "sortTime", "star"];
	bgTextColor = "#000000";
	sortTopics = ["All Topics"];
	sortSubTopics = ["All Sub Topics"];
	sortSenders = ["All Senders"];
	filteredTopic = "";
	filteredSubtopic = "";
	filteredSender = "";
	filteredForm = "";
	tableDataSource = [];
	userPriveleges = [];
	timezone;

	constructor(
		private _trashService: TrashService,
		private _router: Router,
		private _dashboardService: DashboardService,
		private _sharedService: SharedService,
		private _snackBar: MatSnackBar,
		private _changeDetectionRef: ChangeDetectorRef,
		private _filterService: FilterService
	) {
		this._sharedService.searchChange.subscribe(value => {
			this.trashForms.filter = value.toLowerCase();
			if (this.trashForms.filteredData.length === 0) {
				this.displayNoRecords = true;
			} else {
				this.displayNoRecords = false;
			}
			this.updateFiltersForSearch();
		});
	}

	ngOnInit() {
		this.timezone = localStorage.getItem('timezone');
		this.onInit();
	}

	ngAfterViewChecked() {
		if (this.check(this.bgTextColor)) {
			this._sharedService.updateHomeColor(this.bgTextColor);
		}
	}

	check(hex) {
		if (/[0-9A-F]{6}$/i.test(hex)) {
			return true;
		}
	}

	onInit() {
		this._sharedService.getPrivileges(localStorage.getItem('role')).subscribe((response) => {
			if (response['success']) {
				this.userPriveleges = response['data'][0]['privileges'];
			}
			let isHelpAdmin = false
			if (this.checkPrivilege("help_forms")) {
				isHelpAdmin = true
			}
			let searchInput = document.getElementById("searchInput");
			if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
			searchInput["value"] = "";
			this.displayNoRecords = false;
			this.trashForms = [];
			this.sortTopics = ["All Topics"];
			this.sortSubTopics = ["All Sub Topics"];
			this.sortSenders = ["All Senders"];
			this.sortForms = ["All Forms"];
			this.filteredTopic = "";
			this.filteredSubtopic = "";
			this.filteredSender = "";
			this.filteredForm = ""
			this._trashService.getDeletedForms(localStorage.getItem("organization"), isHelpAdmin).subscribe((response) => {
				if (response["success"]) {
					if (response["data"] && response["data"].length > 0) {
						let trashForms = response['data'];
						if (trashForms.length > 0) {
							trashForms.forEach((form) => {
								form["sortTopics"] = form["sortTopics"] ? (_.isString(form["sortTopics"]) ? form["sortTopics"] : Object.values(form["sortTopics"])[0]) : '';
								form["subTopics"] = form["subTopics"] ? (_.isString(form["subTopics"]) ? form["subTopics"] : Object.values(form["subTopics"])[0]) : '';


								if (form["sortTopics"]) {
									if (!_.includes(this.sortTopics, form["sortTopics"])) {
										if (form["sortTopics"] && form["sortTopics"].length !== 0) {
											this.sortTopics.push(form["sortTopics"])
										}
									}
								}

								if (form["subTopics"]) {
									if (!_.includes(this.sortSubTopics, form["subTopics"])) {
										if (form["subTopics"] && form["subTopics"].length !== 0) {
											this.sortSubTopics.push(form["subTopics"]);
										}
									}
								}

								if (form["sortSenders"]) {
									if (!_.includes(this.sortSenders, form["sortSenders"])) {
										if (form["sortSenders"] && form["sortSenders"].length !== 0) {
											this.sortSenders.push(form["sortSenders"]);
										}
									}
								}

								if (!_.includes(this.sortForms, form.sortForms)) {
									if (form["sortForms"] && form["sortForms"].length !== 0) {
										this.sortForms.push(form["sortForms"])
									}
								}

								if (this.timezone) {
									form['sortTime'] = moment(form['sortTime']).tz(this.timezone).format('llll')
								}
								// // Fetching images
								// let template_schema = form["template"]["template_schema"]["schema"];
								// let response = form["response"];

								// template_schema.forEach((element) => {
								//   for (let i = 0; i < Object.keys(response).length ; i++) {
								//     if (response[element.key] !== undefined) {
								//       element["value"] = response[element.key];
								//     }
								//   }

								//   if (element.type === 'picture') {
								//     if (element["value"] && element["value"].length > 0) {
								//       form["raw_images"] = [];
								//       for (let j = 0; j < element["value"].length; j++) {
								//         if (j === 2) {
								//           break;
								//         }
								//         this._s3Service.getObjectFromKey(element["value"][j]).subscribe((response) => {
								//           var binary = '';
								//           var bytes = new Uint16Array(response['data']);
								//           var len = bytes.byteLength;
								//           for (var i = 0; i < len; i++) {
								//             binary += String.fromCharCode(bytes[i]);
								//           }
								//           let image = "data:image/jpeg;base64," + window.btoa(binary);
								//           form["raw_images"].push({ src: image });
								//         }, (error) => {
								//           console.log(error);
								//         });
								//       }
								//     }
								//   }
								// });
							});
							this.sortFilters();
							this.trashForms = new MatTableDataSource(trashForms);
							this.trashForms.sort = this.sort;
							// this._dashboardService.refreshCount([]);
							this.tableDataSource = trashForms;
						}
					}
				}
				this.sortFilters();
			}, (error) => {
				console.error(error);
			});
		})
	}

	getFormDetails(formId) {
		this._router.navigateByUrl('/formDetails/Trash/' + formId);
	}

	archiveSubmittedForm(formId) {
		let requestData = {
			formId: formId
		};

		this._dashboardService.archiveSubmittedForm(requestData).subscribe((response) => {
			if (response["success"]) {
				this.trashForms = [];
				this.onInit();
			}
		}, (error) => {
			console.log(error);
		});
	}

	restoreDeletedForm(formId) {
		// this._sharedService.confirmationDialog("Are you sure you want to restore this form?",() => {
		let requestData = {
			formIds: [formId]
		};

		this._trashService.restoreDeletedForms(requestData).subscribe((response) => {
			this.openSnackBar(response["message"]);
			let forms = this.trashForms._data._value;
			let formIndex = this.trashForms._data._value.findIndex((form) => form._id === formId);
			forms.splice(formIndex, 1);
			this.updateTable(forms);
		}, (error) => {
			console.log(error);
			this.openSnackBar("Server side error occurred");
		});
		// });
	}

	updateTable(forms) {
		this.sortForms = ["All Forms"];
		this.sortTopics = ["All Topics"];
		this.sortSubTopics = ["All Sub Topics"];
		this.sortSenders = ["All Senders"];
		if (forms && forms.length > 0) {
			forms.forEach((form) => {
				form["checked"] = false;
				form["sortTopics"] = form["sortTopics"] ? (_.isString(form["sortTopics"]) ? form["sortTopics"] : Object.values(form["sortTopics"])[0]) : '';
				form["subTopics"] = form["subTopics"] ? (_.isString(form["subTopics"]) ? form["subTopics"] : Object.values(form["subTopics"])[0]) : '';

				if (!_.includes(this.sortForms, form.sortForms)) {
					this.sortForms.push(form.sortForms);
				}

				if (!_.includes(this.sortTopics, form["sortTopics"])) {
					if (form["sortTopics"].length !== 0) {
						this.sortTopics.push(form["sortTopics"])
					}
				}

				if (!_.includes(this.sortSubTopics, form["subTopics"])) {
					if (form["subTopics"].length !== 0) {
						this.sortSubTopics.push(form["subTopics"])
					}
				}

				if (!_.includes(this.sortSenders, form["sortSenders"])) {
					if (form["sortSenders"] && form["sortSenders"].length !== 0) {
						this.sortSenders.push(form["sortSenders"]);
					}
				}
			});

			this.trashForms = new MatTableDataSource(forms);
			this.tableDataSource = forms;
		} else {
			this.trashForms = [];
			this.tableDataSource = [];
		}
	}

	openSnackBar(message) {
		this._snackBar.open(message, "Ok", {
			duration: 2000
		});
	}

	onReloadClick(): void {
		this.onInit();
	}

	filterTopics(value): void {
		if (value === "All Topics") {
			this.filteredTopic = "";
		} else {
			this.filteredTopic = value;
		}

		this.applyFilters();
	}

	filterSubTopics(value): void {
		if (value == "All Sub Topics") {
			this.filteredSubtopic = "";
		} else {
			this.filteredSubtopic = value;
		}
		this.applyFilters();
	}

	filterSenders(value): void {
		if (value == "All Senders") {
			this.filteredSender = "";
		} else {
			this.filteredSender = value;
		}
		this.applyFilters();
	}

	filterForms(value): void {
		if (value == "All Forms") {
			this.filteredForm = "";
		} else {
			this.filteredForm = value;
		}
		this.applyFilters();
	}


	sortFilters() {
		this.sortTopics = this._filterService.sortFilterOptions(this.sortTopics, "All Topics");
		this.sortSubTopics = this._filterService.sortFilterOptions(this.sortSubTopics, "All Sub Topics");
		this.sortSenders = this._filterService.sortFilterOptions(this.sortSenders, "All Senders");
		this.sortForms = this._filterService.sortFilterOptions(this.sortForms, "All Forms");
	}
	checkPrivilege(accessType) {
		return this._sharedService.checkPrivilege(this.userPriveleges, accessType);
	}

	resetFilters() {
		this.filteredForm = "";
		this.filteredTopic = "";
		this.filteredSubtopic = "";
		this.filteredSender = "";
	}


	// Check if any filter is active
	hasActiveFilters(): boolean {
		return this._filterService.hasActiveFilters({
			topic: this.filteredTopic,
			subtopic: this.filteredSubtopic,
			sender: this.filteredSender,
			form: this.filteredForm
		});
	}

	// Clear individual filter
	clearFilter(type: string) {
		switch (type) {
			case 'topic':
				this.filteredTopic = "";
				break;
			case 'subtopic':
				this.filteredSubtopic = "";
				break;
			case 'sender':
				this.filteredSender = "";
				break;
			case 'form':
				this.filteredForm = "";
				break;
		}
		this.applyFilters();
	}

	// Apply all active filters
	applyFilters() {
		const filters = {
			topic: this.filteredTopic,
			subtopic: this.filteredSubtopic,
			sender: this.filteredSender,
			form: this.filteredForm
		};

		const filteredData = this._filterService.applyFilters(this.tableDataSource, filters);

		this.trashForms = new MatTableDataSource(filteredData);
		this.trashForms.sort = this.sort;
		this._changeDetectionRef.detectChanges();
		this.updateFilterLists();
		this.sortFilters();
	}

	// Dynamic update of dropdown lists based on active filters (faceted search)
	updateFilterLists() {
		const filters = {
			topic: this.filteredTopic,
			subtopic: this.filteredSubtopic,
			sender: this.filteredSender,
			form: this.filteredForm
		};

		const options = this._filterService.getFilterOptions(this.tableDataSource, filters);
		this.sortTopics = options.topics;
		this.sortSubTopics = options.subTopics;
		this.sortSenders = options.senders;
		this.sortForms = options.forms;
	}

	// Update filters based on search results
	updateFiltersForSearch() {
		const searchText = this._sharedService.searchText;
		const options = this._filterService.updateFiltersForSearch(this.trashForms, searchText);
		this.sortTopics = options.topics;
		this.sortSubTopics = options.subTopics;
		this.sortSenders = options.senders;
		this.sortForms = options.forms;
		this.sortFilters();
	}
}
